/**
 * 鸿蒙 H5 / 鸿蒙微信 UA 识别（与移动端 utils/uaHarmony.js 保持一致）
 * @see https://developers.weixin.qq.com/doc/subscription/guide/h5/adapt_harmonyos.html
 * 同步维护：src/utils/deviceDetect.js、public/device-detect.boot.js
 */

export function isHarmonyOsUa(ua = '') {
  return /HarmonyOS|OpenHarmony|Harmony/i.test(String(ua))
}

/** 鸿蒙微信：UA 同时含 OpenHarmony + MicroMessenger */
export function isHarmonyWeChatUa(ua = '') {
  const s = String(ua)
  return /OpenHarmony/i.test(s) && /MicroMessenger/i.test(s)
}

export function isHarmonyTabletUa(ua = '') {
  const s = String(ua)
  if (!isHarmonyOsUa(s)) return false
  if (/Tablet|Pad/i.test(s)) return true
  if (/\(PC;\s*OpenHarmony/i.test(s)) return true
  if (/\(Tablet;\s*OpenHarmony/i.test(s)) return true
  return false
}

export function isHarmonyMobileUa(ua = '') {
  const s = String(ua)
  if (!isHarmonyOsUa(s)) return false
  if (isHarmonyTabletUa(s)) return false
  if (/Phone|Mobile/i.test(s)) return true
  if (isHarmonyWeChatUa(s)) return true
  return false
}

/**
 * 华为/荣耀/鸿蒙浏览器：短音效（打字）易因 HTMLAudio 池满丢弃、AudioContext 挂起而只剩零星一声。
 * 仅用于 PC H5 打字音效特殊策略，其它 UA 不命中。
 */
export function isHuaweiTypingAudioFragileUa(ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  const s = String(ua || '')
  if (!s) return false
  return /HUAWEI|Huawei|Honor|HONOR|HarmonyOS|OpenHarmony|\bHarmony\b/i.test(s)
}
